import { useEMTState } from '@/store'
import * as React from 'react'
import NotificationView from './NotificationView'

type Props = {
  defaultErrorDuration?: number
  defaultWarnDuration?: number
  defaultSuccessDuration?: number
  defaultDebugDuration?: number
}

const NotificationsView: React.FC<Props> = ({
  defaultErrorDuration,
  defaultWarnDuration,
  defaultSuccessDuration,
  defaultDebugDuration,
}) => {
  const { currentNotifications } = useEMTState().notifications
  return (
    <div
      style={{
        position: 'fixed',
        right: 0,
        marginLeft: 10,
        marginTop: 75,
        zIndex: 9999,
        maxWidth: 425,
      }}
    >
      {currentNotifications.map((it) => (
        <NotificationView
          key={it.id}
          notification={it}
          defaultDebugDuration={defaultDebugDuration}
          defaultSuccessDuration={defaultSuccessDuration}
          defaultWarnDuration={defaultWarnDuration}
          defaultErrorDuration={defaultErrorDuration}
        />
      ))}
    </div>
  )
}

export default NotificationsView
